<template>
    <swiper
        v-if="slideEnabled"
        :modules="modules"
        :slides-per-view="1"
        :space-between="16"
        :speed="700"
        :pagination="{
            type: 'bullets',
            clickable: 'true',
        }"
        :autoplay="false"
        :loop="false"
    >
        <swiper-slide v-for="(slot, name) in slots">
            <render-vnode :v-node="slot"></render-vnode>
        </swiper-slide>
    </swiper>
    <div v-else>
        <render-vnode v-for="(slot, name) in slots" :v-node="slot"></render-vnode>
    </div>
</template>

<script>
import {computed, useSlots} from "vue";
import { Autoplay, Pagination, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import {breakpointState} from "@/utils";

export default {
    name: "teaser-triple-slider",
    components: {
        Swiper,
        SwiperSlide,
    },
    setup() {

        // Get slots for render as content
        const slots = useSlots().default();

        const slideEnabled = computed(() => {
            return breakpointState.value.cur === 'mobile'
        })
        return {
            slots,
            slideEnabled,
            modules: [Autoplay, Pagination, Navigation],
        }
    }
}
</script>

<style lang="scss">
@use "../scss/design-library/functions/calculate";
@use "../scss/design-library/grid";
@use "../scss/design-library/typography";
@use "../scss/design-library/colors";

.teaser-triple {
    &__inner {
        @include grid.inner();
    }

    &__cell {
        @include grid.cell-span_(3,mobile);
        @include grid.cell-span_(2,tablet_portrait);
        @include grid.cell-span_(3,tablet_landscape);
        @include grid.cell-span_(4,desktop);

        > * {
            display: block;
            height: 100%;

            @include grid.media-query_(mobile) {
                padding-block-end: #{calculate.rem(16)};
            }
        }
    }

    &__wrapper {
        @include grid.media-query_up_(tablet_portrait) {
            height: calc( 100% - #{calculate.rem(50)});
        }
    }

    &__headline {
        margin-block-end: #{calculate.rem(25)};
        > * {
            @include typography.headline3();
        }
    }

    &__item {
        display: flex;
        flex-direction: row;
        column-gap: #{calculate.rem(25)};
        align-items: center;
        text-decoration: none;

        &:hover {
            text-decoration: none;
        }

        @include grid.media-query_up_(tablet_portrait) {
            padding-block-end: #{calculate.rem(25)};
        }

        /*
        &:hover {
            .teaser-triple__item--image {
                transform: scale(1.2);
            }
        }
         */
        &--image {
            display: block;
            @include grid.media-query_(tablet_portrait) {
                display: none;
            }
            flex-basis: #{calculate.rem(162)};
            height: #{calculate.rem(111)};
            border-radius: #{calculate.rem(16)};
            flex-grow: 0;
            flex-shrink: 0;
            overflow: hidden;
            align-self: flex-start;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }


        &--overline {
            @include typography.body2();
            margin-block-end: #{calculate.rem(4)};
            color: #{colors.$anthrazit};
        }

        &--headline {
            font-weight: 700;
            @include typography.headline4();
            margin-block-end: #{calculate.rem(4)};
            color: #{colors.$black};
        }

        &--content {
            @include typography.body2();
            color: #1F252E;
            p {
                @include typography.c2();
                margin-block-end: #{calculate.rem(4)};

            }
        }
    }

    .swiper {
        padding-block-end: #{calculate.rem(10)};
    }
}
</style>
